import { useState, useEffect } from "react";
import {
  Paper,
  TextField,
  Typography,
  IconButton,
  Grid,
  Modal,
  Chip,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";

const ModalAddNoteWithEdition = ({
  open,
  close,
  section,
  note,
  idDocument,
  token,
  refresh,
  addNoteWithEditionToSection,
  isAddingWithEdition,
  selectedDate,
}) => {
  const [titulo, setTitulo] = useState("");
  const [sintesis, setSintesis] = useState("");

  useEffect(() => {
    if (open && note) {
      setTitulo(note.titulo || note.CAPTITULO || "");
      setSintesis(note.sintesis || note.CAPTEXTSINT || "");
    }
  }, [note, open]);

  const handleSave = async () => {
    if (!note) {
      alert("No hay nota seleccionada.");
      return;
    }

    const capclave = note.CAPCLAVE || note.capclave;

    if (!capclave) {
      alert(
        "La nota seleccionada no tiene un identificador válido (CAPCLAVE).",
      );
      console.error("Nota seleccionada sin CAPCLAVE:", note);
      return;
    }

    if (!titulo.trim()) {
      alert("El título es requerido.");
      return;
    }

    if (!sintesis.trim()) {
      alert("La síntesis es requerida.");
      return;
    }

    try {
      const result = await addNoteWithEditionToSection(
        idDocument,
        section.ID_SECCION,
        capclave,
        titulo,
        sintesis,
        token,
        selectedDate,
      );

      if (result.success) {
        close();
        refresh();
      }
    } catch (error) {
      console.error("Error al agregar nota con edición a la sección:", error);
    }
  };

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "80%",
          maxWidth: "600px",
          outline: "none",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={10}>
            <Typography variant="h6">
              Agregar nota a la sección: {section?.NOMBRE_SECCION}
            </Typography>
            <Typography
              variant="subtitle2"
              style={{ color: "#666", marginTop: "5px" }}
            >
              Edita el título y síntesis antes de agregar la nota
            </Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <IconButton onClick={close}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <div>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item xs={12}>
              <TextField
                label="Título"
                name="titulo"
                variant="outlined"
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                fullWidth
                multiline
                maxRows={3}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Síntesis"
                variant="outlined"
                name="sintesis"
                value={sintesis}
                onChange={(e) => setSintesis(e.target.value)}
                fullWidth
                multiline
                minRows={6}
                maxRows={12}
                required
                InputProps={{
                  style: { paddingBottom: "40px" },
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{
                        position: "absolute",
                        bottom: "20px",
                        right: "12px",
                      }}
                    >
                      <Chip
                        size="small"
                        label={
                          sintesis.trim() === ""
                            ? "0 palabras"
                            : `${sintesis.trim().split(/\s+/).length} palabras`
                        }
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Paper style={{ padding: "10px", backgroundColor: "#f5f5f5" }}>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold", marginBottom: "5px" }}
                >
                  Información de la nota original:
                </Typography>
                <Typography
                  variant="body2"
                  style={{ fontSize: "12px", color: "#666" }}
                >
                  <strong>ID:</strong> {note?.CAPCLAVE || note?.capclave} <br />
                  <strong>Título original:</strong>{" "}
                  {note?.titulo || note?.CAPTITULO || "N/A"} <br />
                  <strong>Sección destino:</strong> {section?.NOMBRE_SECCION}
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          <Grid
            container
            justifyContent="flex-end"
            style={{ marginTop: "20px" }}
          >
            <Grid item style={{ marginRight: "10px" }}>
              <Button
                variant="outlined"
                onClick={close}
                disabled={isAddingWithEdition}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={handleSave}
                loading={isAddingWithEdition}
                disabled={!titulo.trim() || !sintesis.trim()}
              >
                Agregar a Sección
              </LoadingButton>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </Modal>
  );
};

export default ModalAddNoteWithEdition;
